import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderVideos = createAsyncThunk("provdier/get-videos", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-videos`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers video");
  }
});

export const addProviderVideo = createAsyncThunk("provider/add-video", async ({ token, video_url }, { rejectWithValue }) => {
    try {

        const formData = new FormData();
        formData.append("video_url", video_url);
        const response = await axios.post(
            `${BACKEND_URL}/provider/add-video`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const updateProviderVideo = createAsyncThunk(
  "provider/update-video",
  async ({ token, id, video_url }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("video_url", video_url);

      const response = await axios.post(
        `${BACKEND_URL}/provider/update-video/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update video");
    }
  }
);

export const deleteProviderVideo = createAsyncThunk(
  "provider/delete-video",
  async ({ token, videoId }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/provider/delete-video/${videoId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete provider video"
      );
    }
  }
);

const providerVideoSlice = createSlice({
  name: "providerVideo",
    initialState: {
      providerVideos: null,
      loading: false,
      error: null,
      message: "",
      
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderVideos.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderVideos.fulfilled, (state, action) => {
            state.providerVideos = action.payload.providerVideos;
            state.loading = false;
        })
        .addCase(getProviderVideos.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers video"; 
            state.loading = false;
        })
        .addCase(addProviderVideo.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.message = "";
        })
        .addCase(addProviderVideo.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload.message;
        })
        .addCase(addProviderVideo.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to add provider video";
        })
        .addCase(updateProviderVideo.fulfilled, (state, action) => {
            state.message = action.payload.message;
        })
        .addCase(deleteProviderVideo.pending, (state) => {
                  state.loading = true;
                })
                .addCase(deleteProviderVideo.fulfilled, (state) => {
                  state.loading = false;
                })
                .addCase(deleteProviderVideo.rejected, (state, action) => {
                  state.error = action.payload || "Failed to delete provider video";
                  state.loading = false;
                })
      },
});

export default providerVideoSlice.reducer;